import React, { Component } from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import YesNoDialog from "./YesNoDialog";
import { withRouter } from "react-router-dom";
import ReactLoading from "react-loading";

import {
  faRedo,
  faPencilAlt,
  faEraser,
  faCheck,
  faCircle
} from "@fortawesome/fontawesome-free-solid";

class Canvas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canvas: {},
      context: {},
      clickX: [],
      clickY: [],
      clickDrag: [],
      CompositeMode: [],
      clickSize: [],
      draw: false,
      activeColor: this.props.activeColor,
      clickColor: [],
      activeLineWidth: this.props.updatePenSize,
      startDraw: this.props.penEnabled,
      startErase: this.props.eraserEnabled,
      showDrawInfo: true,
      showSaveDialog: false,
      uploadStarted: false
    };
    this.handleOnMouseDown  = this.handleOnMouseDown.bind(this);
    this.handleOnMouseMove  = this.handleOnMouseMove.bind(this);
    this.hideDrawInfo = this.hideDrawInfo.bind(this);
    this.handleOnSave = this.handleOnSave.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadStatus === "success") {
      this.props.history.push("/nigoki/thank-you");
    }
    
    if(nextProps.updatePenSize !== this.props.updatePenSize){
      this.setState({
        activeLineWidth: nextProps.updatePenSize,
        startDraw: true,
        startErase: false
      })
    }else if(nextProps.penEnabled === true){
      this.setState({
        startDraw: true,
        startErase: false,
        activeLineWidth: this.props.updatePenSize
      })
    }

    if(nextProps.updateEraserSize !== this.props.updateEraserSize){
      this.setState({
        activeLineWidth: nextProps.updateEraserSize,
        startDraw: false,
        startErase: true
      })
    }else if(nextProps.eraserEnabled === true){
      this.setState({
        startDraw: false,
        startErase: true,
        activeLineWidth: this.props.updateEraserSize
      })
    }

    if(nextProps.activeColor !== this.props.activeColor){
      this.setState({
        activeColor: nextProps.activeColor,
      })
    }

  }
  componentDidMount() {
    this.props.setClick(this.handleOnSave);

    this.drawScreenCapture();

    var canvas = document.getElementById("drawing-canvas");
    this.setState({ canvas });
    this.setState({ context: canvas.getContext("2d") });
    setTimeout(() => {
      this.setState({ showDrawInfo: false });
    }, 5000);

    //stop recording
    var stream = this.props.mediaStream;
    stream.getTracks().forEach(track => track.stop())

  }

  drawScreenCapture() {
    var screen_capture_canvas = document.getElementById("screen-shot-canvas");
    var image_hidden_canvas = document.getElementById("image-hidden-canvas") 
    var SCCWidth = this.props.vWrapper
    var SSCWidth  = this.props.screenCapture.videoWidth;
    var SSCHeight = this.props.screenCapture.videoHeight;
    var imgSize = Math.min(SSCWidth,SSCHeight);
    var left = (SSCWidth - imgSize) / 2;
    var top = (SSCHeight - imgSize) / 2;


    image_hidden_canvas.width = SSCWidth;
    image_hidden_canvas.height = SSCHeight;

    image_hidden_canvas
      .getContext('2d')
      .drawImage(this.props.screenCapture, 0, 0, SSCWidth, SSCHeight);

    // Get canvas contents as a data URL set with highest quality
    var imgAsDataURL = image_hidden_canvas.toDataURL("image/jpeg", 1.0);

    var img = new Image;
      img.src = imgAsDataURL;
      img.onload = function () {
          screen_capture_canvas
          .getContext("2d")
          .drawImage(
            img,
            left,
            top,
            imgSize,
            imgSize,
            0,
            0,
            SCCWidth,
            SCCWidth
          );
      };
  }
  addClick(x, y, dragging) {
    const { clickX, clickY, clickDrag, clickColor, clickSize, CompositeMode } = this.state;
    clickX.push(x);
    clickY.push(y);
    clickDrag.push(dragging);

    if (this.state.startDraw) {
      clickColor.push(this.state.activeColor);
      CompositeMode.push("source-over");
    } else {
      CompositeMode.push("destination-out");
      clickColor.push("rgba(0,0,0,1.0)");
    }
    
    clickSize.push(this.state.activeLineWidth);
  }
  redraw() {
    const {
      context,
      clickX,
      clickY,
      clickDrag,
      clickColor,
      clickSize,
      CompositeMode
    } = this.state;

    context.clearRect(0, 0, context.canvas.width, context.canvas.height); // Clears the canvas
    context.lineJoin = "round";
    for (var i = 0; i < clickX.length; i++) {
      context.beginPath();
      context.globalCompositeOperation = CompositeMode[i];
      if (clickDrag[i] && i) {
        context.moveTo(clickX[i - 1], clickY[i - 1]);
      } else {
        context.moveTo(clickX[i] - 1, clickY[i]);
      }
      context.lineTo(clickX[i], clickY[i]);
      context.closePath();
      context.strokeStyle = clickColor[i];
      context.lineWidth = clickSize[i];
      context.stroke();
    }
  }
  getMousePos(canvas, evt) {
    var rect = canvas.getBoundingClientRect(), // abs. size of element
        scaleX = canvas.width / rect.width,    // relationship bitmap vs. element for X
        scaleY = canvas.height / rect.height;  // relationship bitmap vs. element for Y
  
    return {
      x: (evt.clientX - rect.left) * scaleX,   // scale mouse coordinates after they have
      y: (evt.clientY - rect.top) * scaleY     // been adjusted to be relative to element
    }
  }
  handleOnMouseDown(e) {
    
    // if(this.state.startDraw){
      var pos = this.getMousePos(this.state.canvas, e);
      const { offsetLeft, offsetTop } = this.state.canvas;
      
      var mouseX = pos.x - offsetLeft;
      var mouseY = pos.y - offsetTop;
      this.setState({ draw: true });
      this.addClick(mouseX, mouseY);
      this.redraw();
    // }

  }
  handleOnMouseMove(e) {
    var pos = this.getMousePos(this.state.canvas, e);
    let pageX, pageY;
    if (e.touches) {
      pageX = e.touches[0].pageX;
      pageY = e.touches[0].pageY;
    } else {
      pageX =  pos.x;
      pageY =  pos.y;
    }
    const { offsetLeft, offsetTop } = this.state.canvas;
    if (this.state.draw) {
      this.addClick(pageX - offsetLeft, pageY - offsetTop, true);
      this.redraw();
    }

  }

  hideDrawInfo() {
    this.setState({
      showDrawInfo: false
    });
  }
  handleOnSave() {
    let screenshot_canvas = document.getElementById("screen-shot-canvas");
    let drawing_canvas = document.getElementById("drawing-canvas");
    
    this.setState({ showSaveDialog: true }, () => {
      let merged_canvas = document.getElementById("merged-canvas");
      let output_canvas = document.getElementById("output-canvas");
      merged_canvas.getContext("2d").globalCompositeOperation =
        "destination-over";
      merged_canvas.getContext("2d").drawImage(drawing_canvas, 0, 0);
      merged_canvas.getContext("2d").drawImage(screenshot_canvas, 0, 0);

      output_canvas.getContext("2d").globalCompositeOperation =
        "destination-over";
      output_canvas.getContext("2d").drawImage(merged_canvas, 0, 0, 600, 600)
    });
  }
  render() {
    return (
      <div className="paper-bg">
        <canvas id="image-hidden-canvas"></canvas>
        <div className="video-bg">
          <div id="screen-shot-canvas-wrapper"
          style={{ 
            width: this.props.vWrapper + "px",
            height: this.props.vWrapper + "px"
          }}
          >
            {this.state.showSaveDialog ? (
              <div style={{ minHeight: "100%", minWidth: "100%" }}>
                {!this.state.uploadStarted ? (
                <YesNoDialog
                  question="Are you sure you want to save this photo?"
                  handleOnClickYes={() =>
                    this.setState(
                      { uploadStarted: true },
                      this.props.sendDrawing(
                        document
                          .getElementById("output-canvas")
                          .toDataURL("image/jpeg", 1.0)
                      )
                    )
                  }
                  handleOnClickNo={() =>
                    this.setState({ showSaveDialog: false }, this.drawScreenCapture)
                  }
                />
                ) : null }
                
                <canvas
                  id="merged-canvas"
                  style={{ top: "0px" }}
                  height={this.props.vWrapper}
                  width={this.props.vWrapper}
                />
                <canvas id="output-canvas" width={this.props.vWrapper} height={this.props.vWrapper} />
                {this.state.uploadStarted ? (
                  <ReactLoading
                    className="canvas-loading"
                    type={"spinningBubbles"}
                    color={"yellow"}
                  />
                ) : null}
                {this.props.uploadStatus ? (
                  this.props.uploadStatus === "failed" ? (
                    <div
                      style={{ bottom: "0px", right: "0px", position: "absolute" }}
                    >
                      failed
                    </div>
                  ) : (
                    <div
                      style={{ bottom: "0px", right: "0px", position: "absolute" }}
                    >
                      passed
                    </div>
                  )
                ) : null}
              </div>
            ) : (
              <div>
                <canvas
                  id="screen-shot-canvas"
                  height={this.props.vWrapper}
                  width={this.props.vWrapper}
                />
                <canvas
                  id="drawing-canvas"
                  style={{ top: "0", left: "0" }}
                  touch-action="none"
                  onPointerDown={this.handleOnMouseDown}
                  onPointerMove={this.handleOnMouseMove}
                  onPointerLeave={() => this.setState({ draw: false })}
                  onPointerUp={() => this.setState({ draw: false })}
                  height={this.props.vWrapper}
                  width={this.props.vWrapper}
                >
                  {" "}
                </canvas>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Canvas);

const styles = {
  logo: {
    display: "block",
    fontSize: "40px",
    position: "absolute",
    zIndex: 3,
    left: "20px",
    top: "10px",
    cursor: "pointer",
    color: "black"
  },
  drawinfo: {
    position: "fixed",
    whiteSpace: "nowrap",
    right: "100px",
    color: "white"
  }
};



// WEBPACK FOOTER //
// ./src/components/Canvas.js